/* eslint-disable @next/next/no-img-element */
import React from 'react'
import Image from 'next/image'
import { CardData } from './productHealthInfoCardData'
import styles from './productHealthInfoCard.module.scss'

const Card = (src, title, subtitle, isMobile) => (
  <div className={styles.CardContainer}>
    <Image
      src={src}
      width={isMobile ? '32' : '40'}
      height={isMobile ? '32' : '40'}
      className={styles.ImageContainer}
      alt={`${title || ''} ${subtitle || ''}`}
    />
    <div className={styles.Heading}>{title}</div>
    <h4 className={styles.SubHeading}>{subtitle}</h4>
  </div>
)

const ProductHealthInfoCards = ({ isMobile, isHealthWidgetLayout, widget }) => {
  if (!isHealthWidgetLayout) return null
  return (
    <div className={styles.RootContainer}>
      {CardData[widget]?.map(item =>
        Card(
          item?.icon,
          isMobile ? item?.heading?.mobile : item?.heading?.web,
          isMobile ? item?.subHeading?.mobile : item?.subHeading?.web,
          isMobile
        )
      )}
    </div>
  )
}

export default ProductHealthInfoCards
